import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const transcribeShotclass = (shotclassId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.TRANSCRIBE_SHOTCLASS(shotclassId)
  );
};

export default transcribeShotclass;
